document.addEventListener('DOMContentLoaded', function() {
    const openMenuMobile = document.getElementById('open-menu-mobile');
    const menuMobile = document.getElementById('menu-mobile');

    if(openMenuMobile){
        openMenuMobile.addEventListener('click', function() {
            menuMobile.classList.toggle('open');
        });

        openMenuMobile.addEventListener('click', function() {
            openMenuMobile.classList.toggle('active');
        });
    }

    window.addEventListener('scroll', function () {
      const annoucementBar = document.querySelector('#shopify-section-announcement-bar-custom');
      const header = document.querySelector('.container-items-menu');
      const submenu = document.querySelector('.list-Submenu.sub-menu-modal');
      const btnFilter = document.querySelector('.collection-filter .filter-btn');
      const menuFilter = document.querySelector('.collection-filter .aside-filter');

      const shouldAdd = window.scrollY > 0;

      const toggleClass = (el, className) => {
          if (el?.classList) {
              el.classList[shouldAdd ? 'add' : 'remove'](className);
          }
      };

      toggleClass(menuMobile, 'menu-mobile-scroll');
      toggleClass(annoucementBar, 'scrolledA');
      toggleClass(header, 'scrolled');
      toggleClass(header, 'bg-white');
      toggleClass(submenu, 'scrolled-submenu');
      toggleClass(btnFilter, 'scrolled_filter');
      toggleClass(menuFilter, 'scrolled_menu_filter');
  });
});
